import { render } from "./TekstenView.vue?vue&type=template&id=08afed36"
import script from "./TekstenView.vue?vue&type=script&lang=js"
export * from "./TekstenView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__